import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

import RequiredAuth from './RequiredAuth';
import MainLayout from '../components/layout/MainLayout';
import Login from '../components/pages/Login';
import NotFound from '../components/pages/NotFound';

import AboutUs from '../components/templates/About';
import Agent from '../components/templates/Agent';
import Comment from '../components/templates/Comment';
import ConfirmLocation from '../components/templates/ConfirmLocation';
import EstimatedPrice from '../components/templates/EstimatedPrice';
import EstimateTime from '../components/templates/estimate-time/EstimateTime';
import Forbidden from '../components/templates/Forbidden';
import Job from '../components/templates/Job';
import Main from '../components/templates/MainPage';
import Mobile from '../components/templates/Mobile';
import Question from '../components/templates/Question';
import Register from '../components/templates/Register';
import Services from '../components/templates/Services';
import Support from '../components/templates/Support';
import Tracking from '../components/templates/Tracking';

import Order from '../components/templates/sendPackage/Order';
import Orders from '../components/templates/profile/orders/orders';
import OrdersDetails from '../components/templates/profile/orders/ordersDetails';
import Profile from '../components/templates/profile/profile';
import Requests from '../components/templates/profile/requests/Requests';
import Request from '../components/templates/profile/requests/Request';
import Store from '../components/templates/storeRegistration/Store';

const Router = () => {
   const { isAuthenticated } = useSelector((state) => state.auth);

   return (
      <Routes>
         <Route path='/login' element={isAuthenticated ? <Navigate replace to='/' /> : <Login />} />

         <Route element={<MainLayout />}>
            <Route path='/'>
               <Route index element={<Main />} />

               <Route path='aboutUs' element={<AboutUs />} />
               <Route path='agent' element={<Agent />} />
               <Route path='comments' element={<Comment />} />
               <Route path='confirmLocation/:locationId' element={<ConfirmLocation />} />
               <Route path='estimate-price' element={<EstimatedPrice />} />
               <Route path='estimate-time' element={<EstimateTime />} />
               <Route path='forbidden' element={<Forbidden />} />
               <Route path='job' element={<Job />} />
               <Route path='mobile' element={<Mobile />} />
               <Route path='question' element={<Question />} />
               <Route path='registered' element={<Register />} />
               <Route path='services' element={<Services />} />
               <Route path='support' element={<Support />} />
               <Route path='tracking' element={<Tracking />} />
               <Route path='tracking/:trackingNumber' element={<Tracking />} />

               <Route element={<RequiredAuth />}>
                  <Route path='order' element={<Order />} />
                  <Route path='orders' element={<Orders />} />
                  <Route path='order-details/:trackingNumber' element={<OrdersDetails />} />
                  <Route path='profile' element={<Profile />} />
                  <Route path='requests' element={<Requests />} />
                  <Route path='request-details/:reqId' element={<Request />} />
                  <Route path='store' element={<Store />} />
               </Route>
            </Route>

            <Route path='*' element={<NotFound />} />
         </Route>
      </Routes>
   );
};

export default Router;
